import axios from "axios"

import AES from "@/libs/AES"
const addErrorLog = errorInfo => {
  const { statusText, status, request: { responseURL } } = errorInfo
  let info = {
    type: "ajax",
    code: status,
    mes: statusText,
    url: responseURL
  }
  // if (!responseURL.includes('save_error_logger')) store.dispatch('addErrorLog', info)
}

class HttpRequest {
  constructor(baseUrl = baseURL) {
    this.baseUrl = baseUrl
    this.queue = {}
  }
  getInsideConfig() {
    const config = {
      baseURL: this.baseUrl
    }
    return config
  }
  destroy(url) {
    delete this.queue[url]
    if (!Object.keys(this.queue).length) {
      // Spin.hide()
    }
  }
  interceptors(instance, url) {
    // 请求拦截
    instance.interceptors.request.use(config => {
      if (GlobalVariable.OpenRequestParaSecrect) {
        if (config.method === "Post" || config.method === "post" || config.method === "POST") {
          if (config.data !== undefined && config.data !== "undefined") {
            let str = JSON.stringify(config.data);
            let baseParams = AES.encrypt(str);

            config.data = { data: baseParams };
          }
        } else if (config.method === "get" || config.method === "Get" || config.method === "GET" || config.method === "delete" || config.method === "DELETE" || config.method === "Delete") {
          let baseurl = config.baseURL.pro;
          let url = config.url;
          let strs = url.replace(baseurl, "");

          let params = strs.split("?");
          if (params.length > 1) {
            let str = JSON.stringify(params[1]);
            let baseParams = AES.encrypt(str);

            let strss = baseurl + params[0] + "?data=" + baseParams;

            config.url = strss;
            console.log(config.url);
          }
        }
      }
      // 添加全局的loading...
      if (!Object.keys(this.queue).length) {
        // Spin.show() // 不建议开启，因为界面不友好
      }
      this.queue[url] = true
      return config
    }, error => {
      return Promise.reject(error)
    })
    // 响应拦截
    instance.interceptors.response.use(res => {
      // console.log(res);
      this.destroy(url)

      if (GlobalVariable.OpenRequestParaSecrect) {
        var jsonDataStr = JSON.parse(AES.decrypt(res.data));
        res.data = jsonDataStr;
      }
      const { data, status } = res
      return { data, status }
    }, error => {
      this.destroy(url)
      let errorInfo = error.response
      if (!errorInfo) {
        const { request: { statusText, status }, config } = JSON.parse(JSON.stringify(error))
        errorInfo = {
          statusText,
          status,
          request: { responseURL: config.url }
        }
      }
      addErrorLog(errorInfo)
      return Promise.reject(error)
    })
  }
  //发送请求钱
  request(options) {
    const instance = axios.create()
    options = Object.assign(this.getInsideConfig(), options)
    this.interceptors(instance, options.url)
    return instance(options)
  }
}
export default HttpRequest



// WEBPACK FOOTER //
// ./src/libs/axios.js